import api from '../../utils/api';
import utilities from '../../utils/utilities';
import router from '../../router';

// initial state
const state = {
    email: '',
    completedSuccessfully: false,
    errors: {}
};

// mutations
const mutations = {
    init(state) {
        state.email = '';
        state.errors = {};
        state.completedSuccessfully = false;
    },
    email(state, email) {
        state.email = email;
    },
    completedSuccessfully(state, completedSuccessfully) {
        state.completedSuccessfully = completedSuccessfully;
    },
    errors(state, errors) {
        state.errors = errors;
    }
};

// getters
const getters = {
};

// actions
const actions = {
    load(store) {
        store.commit('init');
    },
    setEmail(store, payload) {
        store.commit('email', payload);
    },
    send(store, btn) {
        utilities.disableButton(btn);
        api.post(
            '/api/account/sendPasswordResetLink',
            {
                email: store.state.email
            },
            'forgotPassword/errors').then(
            function() {
                store.commit('completedSuccessfully', true);
            },
            function() {
                utilities.enableButton(btn);
            });
    },
    openSignIn(store) {
        router.push({
            name: 'signin',
            query: { l: store.rootState.settings.culture }
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/forgotPassword.js